<template>
  <v-app>
    <v-main>
      <v-container>

        <h1> ELIMINACIÓN DE DATOS PERSONALES </h1>

        <p>&nbsp;</p>

        <p>
          <strong>USAMEDIC</strong> garantiza la confidencialidad de los datos proporcionados, los que única y exclusivamente serán utilizados para los fines acordados entre las partes.
          Si usted desea la eliminación de sus datos personales de nuestra base de datos, por favor escríbanos al siguiente correo electrónico e incluya la información solicitada:
          <strong>usamedicina@gmail.com</strong>
        </p>

        <p>&nbsp;</p>

        <ul>

          <li> Dirección de correo electrónico y/o nombre de usuario de la red social con la que se registró (Google, Facebook, Instagram, etc). </li>
          <li> Dirección de correo electrónico para enviar la confirmación de eliminación de datos. </li>
          <li> Motivos por los cuáles desea borrar sus datos. </li>

        </ul>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
}
</script>
